<script>
  import { mapGetters, mapActions } from 'vuex'
  import DeviceInfo from '@/modules/util/deviceInfo'
  import moment from 'moment'
  import { IsValid, HashCodeFromInt } from '@/modules/helper/index'

  export default {
     computed: {
      ...mapGetters([
        'MainMenuLayout',
        'AppConfig',
        'DesignSettings',
        'resource',
        'CustomCode'
      ]),
      SubscriptionModuleId() {
        return this.$f7route.params.Id
      },
      GetEditorUtil() {
        let CodeEditorAppUtil = {
            Base: this.AppConfig.Urls.ContentBaseUrl + '/' + this.AppConfig.Subscription_GUID+ '/app/custom-code/' + this.SubscriptionModuleId
        };
        CodeEditorAppUtil.Assets = CodeEditorAppUtil.Base + '/' + 'assets';
        CodeEditorAppUtil.JS = CodeEditorAppUtil.Base + '/' + 'js';
        CodeEditorAppUtil.CSS = CodeEditorAppUtil.Base + '/' + 'css';
        return CodeEditorAppUtil;
      }
    },
    created() {
      this.initCustomCode(this.SubscriptionModuleId)
    },
    watch: {
      SubscriptionModuleId(val, oldval) {
        if (val != oldval) {
          this.initCustomCode(this.SubscriptionModuleId)
          // this.loadIframedata()
        }
      },
      CustomCode(val, oldval) {
        if (val != oldval) {
          this.loadIframedata()
        }
      }
    },
    // mounted() {
    //   this.loadIframedata()
    // },
    methods: {
      ...mapActions([
        'loadLocalCustomCodeData',
        'loadCustomCode'
      ]),
      initCustomCode(SubscriptionModuleId) {
        this.$showLoader()
        this.loadLocalCustomCodeData(SubscriptionModuleId)
        this.loadCustomCode(SubscriptionModuleId).then(() => {
          // this.loadIframedata()
          this.$hideLoader()
          this.$RegisterPageView({'SubscriptionModule_Id': SubscriptionModuleId, 'ContentGUID': 'this.CodeEditor.Id', 'ViewType': 1})
        }).catch(err => {
          console.log('err', err)
          this.$hideLoader()
        })
      },
      loadIframedata() {
         let doc = document.getElementById('customCodeFrame').contentWindow.document
         doc.write(this.buildCodeEditorOutput(this.CustomCode))
         doc.close()
      },
      buildCodeEditorOutput (data) {
        let tempHtml = `
        <!DOCTYPE html>
          <html lang="en">
            <head>
              <meta charset="UTF-8">
        `
        if (IsValid(data.CustomCodeCSS)) {
            tempHtml += '<style type="text/css">\n'
            tempHtml += this.FormatCSSNJSHTML(data.CustomCodeCSS)
            tempHtml += `\nbody { background-color: ${HashCodeFromInt(this.DesignSettings.BackgroundColor)}; color: ${HashCodeFromInt(this.DesignSettings.BackgroundFontColor)}; }\n`
            tempHtml += '\n</style>\n'
        }
        let CodeEditorAppUtil = this.GetEditorUtil;
        tempHtml += `<link class='CodeEditorExtCss' rel='stylesheet' href='${CodeEditorAppUtil.CSS}/costom-code-editor-default-file.css?${moment()}' type='text/css'/>`;
        tempHtml += `<script class='CodeEditorExtJS'  src='${CodeEditorAppUtil.JS}/costom-code-editor-default-file.js?${moment()}' type='text/javascript' charset='utf-8'></\script>`;
        tempHtml += '</head>\n'
        tempHtml += '<body>'
        if (IsValid(data.CustomCodeHTML)) {
            tempHtml += this.FormatHTMLForDisplay(data.CustomCodeHTML, data.SubscriptionModule_Id)
        }
        if (IsValid(data.CustomCodeJavaScript)) {
          tempHtml += `<script>`
          tempHtml += data.CustomCodeJavaScript;
          tempHtml += '</\script>'
        }

        tempHtml += '</body>'
        tempHtml += '</html>'
        return tempHtml;
      },
      FormatHTMLForDisplay(content, SubscriptionModule_Id) {
        // var $element =  this.$('<div></div>', { html: content }) //  , $srcElements, srcValue;
        //     $("*", $element).each(function (key, val) {
        //         $(val.attributes).each(function () {
        //             if (this.nodeName !== 'id') {
        //                 // this.nodeValue = this.nodeValue.replace(/(CodeEditorAppUtil.Assets)/g, GetEditorUtil().Assets);
        //             }
        //         })
        //     })
          return content
      },
      FormatCSSNJSHTML(content) {
        return content.replace(/(\.\.\/assets\/)/g, (this.GetEditorUtil.Assets + '/'));
      }
    }
  }
</script>
<template>
  <f7-page  ref="customCode"  :page-content="false" name="custom-code-view">
    <app-header :header="CustomCode.PageTitle"></app-header>
    <app-tab-menu v-if="MainMenuLayout === 1"></app-tab-menu>
    <f7-page-content class="no-scroll">
      <iframe id="customCodeFrame" frameborder="0" class="IframeCssClass" allowfullscreen>
      </iframe>
    </f7-page-content>
  </f7-page>
</template>
<style scoped>
  .no-scroll {
    overflow: hidden!important;
  }
  .IframeCssClass {
    width: 100%;
    border: none !important;
    height: inherit;
    padding: 0;
    margin: 0;
    float: left;
  }
 </style>



// WEBPACK FOOTER //
// src/components/custom-code/CustomCode.vue